import React from "react";

export default class ErrorPopup extends React.Component<any, any>{
    

    render() {
        let { msg } = this.props;
        return (
            <div id="id01" className="error-modal" style={{ display: msg.length ? "block" : "none" }}>
                <div className="popupInner">
                    <div className="popupHead">
                        <p>Error</p>
                    </div>
                    <div className="popupContent">
                        <div className="ChallengePopup_itemRow">
                            {
                                Array.isArray(msg) ? <div>
                                    <p>Below Mentioned Pages Marked Both Unwanted & Reviewed At Same Time..Please Recheck And Mark Pages As Either Reviewed Or Unwanted</p>
                                    <ol>
                                        {
                                            msg?.map((obj) => (
                                                <li>{obj?.name}</li>
                                            ))
                                        }
                                    </ol>
                                </div> : <span>{msg}</span>
                            }
                        </div>
                    </div>
                    <div className="popupFooter" style={{justifyContent: "flex-end"}}>
                        <div className="close-btn" onClick={()=> this.props.handleClose()}>Discard</div>
                    </div>
                </div>
            </div>
        )
    }

}
